import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;
const { TextArea } = Input;

const mapPropsToFields = (props) => {
  const { dataSource } = props;

  const {
    notes
  } = dataSource;

  return {
    notes: Form.createFormField({ value: notes })
  };
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  dataSource, form
}) => {
  const { notes } = dataSource;
  const { getFieldDecorator } = form;

  return (
    <Form layout="vertical">
      <FormItem label="Notes">
        {getFieldDecorator('notes', {
          initialValue: notes
        })(
          <TextArea maxLength={5000} rows={10} />
        )}
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  dataSource: PropTypes.object,
  form: PropTypes.object
};

FormInput.defaultProps = {
  dataSource: {},
  form: {}
};

const TravelInput = FormWrapper(Form.create({
  onValuesChange,
  mapPropsToFields
})(FormInput));

export default TravelInput;
